import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import Admin from "@/Admin";
import SiteGate from "@/SiteGate";

function Router() {
  const path = window.location.pathname;
  if (path.startsWith('/admin')) {
    // Admin has its own separate passcode (7635) — no site gate here
    return <Admin />;
  }
  // All other pages are behind the site gate (2211)
  return (
    <SiteGate>
      <App />
    </SiteGate>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
);
